import { useState, useEffect, useCallback } from 'react'
import { useAuth } from './useAuth'
import { storage } from '@/lib/storage'

export const DISMISSED_KEY = 'onboardingDismissed'
export const COMPLETED_KEY = 'onboardingCompleted'

export function useNewUserOnboarding() {
    const { user } = useAuth()
    const [showOnboarding, setShowOnboarding] = useState(false)

    useEffect(() => {
        if (user) return

        const hasCompleted = localStorage.getItem(COMPLETED_KEY) === 'true'
        const hasDismissed = localStorage.getItem(DISMISSED_KEY) === 'true'
        const hasSettedId = storage.read(`user_id_1XBET`) !== null || storage.read(`user_id_BETWINNER`) !== null || storage.read(`user_id_MELBET`) !== null

        if (!hasCompleted && !hasDismissed && !hasSettedId) {
            const timer = setTimeout(() => {
                setShowOnboarding(true)
            }, 1500)

            return () => clearTimeout(timer)
        }
    }, [user])

    const dismiss = useCallback(() => {
        setShowOnboarding(false)
        localStorage.setItem(DISMISSED_KEY, 'true')
    }, [])

    return { showOnboarding, setShowOnboarding: dismiss }
}
